<template>
  <div id="app">
<!--    <div style="z-index: -4200; top:0; bottom: 0; left: 0; right: 0; position: fixed"></div>-->
    <loader :loaded="loaded"></loader>
    <router-view></router-view>
    <CookiePopup></CookiePopup>
  </div>
</template>
<script>
import Loader from "@/components/Loader";
import CookiePopup from "@/components/CookiePopup";

export default {
  name: "App",
  components: {CookiePopup, Loader},
  data() {
    return {
      loaded: false
    }
  },
  mounted() {
    document.onreadystatechange = () => {
      if(document.readyState === "complete") {
        this.loaded = true;
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
